/*=========================================================================================
  File Name: moduleRequestTypeConfig.js
  Description: Request Type Config Module

==========================================================================================*/

import state from "./moduleRequestTypeConfigState.js";
import mutations from "./moduleRequestTypeConfigMutations.js";
import actions from "./moduleRequestTypeConfigActions.js";
import getters from "./moduleRequestTypeConfigGetters.js";

export default {
	namespaced: true,
	state,
	mutations,
	actions,
	getters
};
